import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { NativeSelect } from '@/components/ui/native-select'
import type { AgendaValues } from '@/lib/task-form'

interface TaskAgendaFieldsProps {
  value: AgendaValues
  onChange: (value: AgendaValues) => void
  error?: string
}

/** Compromisso de agenda (audiência/reunião) criado junto com a tarefa. */
export function TaskAgendaFields({ value, onChange, error }: TaskAgendaFieldsProps) {
  const set = (patch: Partial<AgendaValues>) => onChange({ ...value, ...patch })
  return (
    <fieldset className="flex flex-col gap-2 rounded-md border p-3">
      <label className="flex items-center gap-2 text-sm font-medium">
        <input
          type="checkbox"
          checked={value.enabled}
          onChange={(e) => set({ enabled: e.target.checked })}
          aria-label="Criar compromisso na agenda"
        />
        Criar compromisso na agenda
      </label>
      {value.enabled && (
        <div className="grid grid-cols-2 gap-2">
          <div className="col-span-2 flex flex-col gap-1">
            <Label htmlFor="agenda-tipo">Tipo</Label>
            <NativeSelect id="agenda-tipo" value={value.tipo} onChange={(e) => set({ tipo: e.target.value as AgendaValues['tipo'] })}>
              <option value="AUDIENCIA">Audiência</option>
              <option value="REUNIAO">Reunião</option>
              <option value="COMPROMISSO">Outro compromisso</option>
            </NativeSelect>
          </div>
          <div className="col-span-2 flex flex-col gap-1">
            <Label htmlFor="agenda-data">Data</Label>
            <Input id="agenda-data" type="date" value={value.data} onChange={(e) => set({ data: e.target.value })} />
          </div>
          <div className="flex flex-col gap-1">
            <Label htmlFor="agenda-inicio">Início</Label>
            <Input id="agenda-inicio" type="time" value={value.inicio} onChange={(e) => set({ inicio: e.target.value })} />
          </div>
          <div className="flex flex-col gap-1">
            <Label htmlFor="agenda-fim">Fim</Label>
            <Input id="agenda-fim" type="time" value={value.fim} onChange={(e) => set({ fim: e.target.value })} />
          </div>
          <div className="col-span-2 flex flex-col gap-1">
            <Label htmlFor="agenda-local">Local</Label>
            <Input id="agenda-local" value={value.local} placeholder="Fórum, sala ou link" onChange={(e) => set({ local: e.target.value })} />
          </div>
          <p className="col-span-2 text-xs text-muted-foreground">Sem hora = dia inteiro. O compromisso aparece na agenda em instantes.</p>
        </div>
      )}
      {error && <p role="alert" className="text-xs text-destructive">{error}</p>}
    </fieldset>
  )
}
